import { getAnimationConfiguration } from '../../hooks/helpers';
import animationData from '../../lotties/software.json';

export const defaultOptions = getAnimationConfiguration(animationData);
